import { render, staticRenderFns } from "./AuthorizationInfo.vue?vue&type=template&id=d9e36082&"
import script from "./AuthorizationInfo.vue?vue&type=script&lang=js&"
export * from "./AuthorizationInfo.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationInfo.vue?vue&type=style&index=0&id=d9e36082&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports